import { useMap } from 'react-leaflet';
import L from 'leaflet';
import { useEffect } from 'react';
import '../Map/LayersControlPanel.css';

// MapButton component for custom buttons on the map

function MapButton({ icon, title, onClick, controlClass }) {
  
  const map = useMap();

  useEffect(() => {

    // Create a <div> element with Leaflet control styling
    const cssClass = `leaflet-bar leaflet-control map-button-control ${controlClass || ''}`.trim();
    const controlDiv = L.DomUtil.create('div', cssClass);

    controlDiv.innerHTML = `
      <a href="${title}" title="${title}" class="map-button">
        <img src="${icon}" alt="${title}" style="width: 24px; height: 24px;">
      </a>
    `;

    // Prevent map interactions when clicking/scrolling on the button
    L.DomEvent.disableClickPropagation(controlDiv);
    L.DomEvent.disableScrollPropagation(controlDiv);

    // Hook up click handler
    const button = controlDiv.querySelector('.map-button');
    const handleClick = (e) => {
      e.preventDefault();
      onClick();
    };
    button.addEventListener('click', handleClick);

    // Create a Leaflet control and add it to the map
    const control = L.control({ position: 'topleft' });
    control.onAdd = () => controlDiv;
    control.addTo(map);

     // Cleanup: remove event listener to avoid duplicates
    return () => {
      button.removeEventListener('click', handleClick);
      map.removeControl(control);
    };
  }, [map, icon, title, controlClass, onClick]);

  return null;
}

export default MapButton;